import {
  CONFIRMATION_FILE_TYPE,
  ORDER_STATUS_TYPE,
} from '@/api/type/commonTypes';
import {
  GetOrderDetailResponse,
  GetOrderListResponse,
  HISTORY_TYPE,
} from '@/api/type/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OrderState {
  orderList: GetOrderListResponse | null;
  completedOrderList: GetOrderListResponse | null;
  // orderDetail: GetOrderDetailResponse;
  orderDetails: Record<string, GetOrderDetailResponse>; // 아코디언으로 오더 상세 여러개 노출을 위한 key 분리
}

const initialState: OrderState = {
  orderList: null,
  completedOrderList: null,
  // orderDetail: {
  //   comments: '',
  //   options: [],
  //   partnerConfirmationFiles: [],
  //   playerConfirmationFiles: [],
  //   attachedFiles: [],
  //   history: [],
  //   designOnly: false,
  // },
  orderDetails: {},
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setOrderList: (state, action: PayloadAction<GetOrderListResponse>) => {
      state.orderList = action.payload;
    },
    setCompletedOrderList: (
      state,
      action: PayloadAction<GetOrderListResponse>
    ) => {
      state.completedOrderList = action.payload;
    },
    // setOrderDetail: (state, action: PayloadAction<GetOrderDetailResponse>) => {
    //   state.orderDetail = action.payload;
    // },
    // deletePartnerConfirmFile: (state, action: PayloadAction<string>) => {
    //   const fileId = action.payload;
    //   state.orderDetail.partnerConfirmationFiles =
    //     state.orderDetail.partnerConfirmationFiles.filter(
    //       (file) => file.id !== fileId
    //     );
    // },
    setOrderDetail: (
      state,
      action: PayloadAction<{ orderId: string; data: GetOrderDetailResponse }>
    ) => {
      state.orderDetails[action.payload.orderId] = action.payload.data;
    },
    deletePartnerConfirmFile: (
      state,
      action: PayloadAction<{ orderId: string; fileId: string }>
    ) => {
      const { orderId, fileId } = action.payload;
      const detail = state.orderDetails[orderId];
      if (!detail) return;

      detail.partnerConfirmationFiles = detail.partnerConfirmationFiles.filter(
        (file) => file.id !== fileId
      );
    },
    addPartnerConfirmFiles: (
      state,
      action: PayloadAction<{
        orderId: string;
        files: CONFIRMATION_FILE_TYPE[];
      }>
    ) => {
      const { orderId, files } = action.payload;
      const detail = state.orderDetails[orderId];
      if (!detail) return;

      detail.partnerConfirmationFiles = [
        ...detail.partnerConfirmationFiles,
        ...files,
      ];
    },
    // 주문 상태 변경
    updateOrderStatus: (
      state,
      action: PayloadAction<{
        orderId: string;
        status: ORDER_STATUS_TYPE;
        history: HISTORY_TYPE;
        rejectReason?: string;
      }>
    ) => {
      if (!state.orderList) return;

      const { orderId, status, rejectReason, history } = action.payload;
      // 주문 완료 시 목록에서 제거
      if (status === 'COMPLETED') {
        state.orderList.items = state.orderList.items.filter(
          (item) => item.orderId !== orderId
        );
      } else {
        // 그 외 상태는 기존대로 업데이트
        const target = state.orderList.items.find(
          (item) => item.orderId === orderId
        );
        if (target) {
          target.status = status;
          if (status === 'REJECTED') {
            target.rejectionReason = rejectReason;
          }
        }
      }

      // 주문 상세 히스토리 추가
      const detail = state.orderDetails[orderId];
      if (detail) {
        detail.history = [...detail.history, history];
      }
    },
  },
});

export const order = orderSlice.actions;
export default orderSlice.reducer;
